import type { FaireProductEntity } from "../../entity_types/product";

export const p_xmbxfe9vyk: FaireProductEntity = {
  token: "p_xmbxfe9vyk",
  type: "product",
  name: "Honey Bee Sampler gift set",
  brandToken: "b_j4haqxftb2",
  brandName: "Magpie",
  imageUrl:
    "https://cdn.faire.com/fastly/39a6d77eed079227ffcb79610deb7ab5c91f4fd7b884b03d8b8f477298159454.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e6b6080b70c6feb5eeb6f373727bf89c5b4c01f8666a57b62bc839c31e43fd81.jpeg",
    "https://cdn.faire.com/fastly/2422fc6814b3a192414d4108f6a2843fc1fa654c9e1fb06ed0a383580d04be52.jpeg",
  ],
  priceDollars: 10,
  description:
    "A charming, ready-to-gift collection inspired by the warmth and sweetness of the hive. Our Honey Bee Sampler Gift Set features a curated assortment of customer favorites, beautifully arranged in a reusable mini basket with natural textures and a cozy, elevated feel.\n\nThis set includes a blend of honey-inspired self-care essentials—perfect for gifting, travel, or introducing new customers to your best-selling scents. Each item is thoughtfully selected to create a soothing, indulgent experience with soft, comforting notes of golden honey.\n\nFinished with simple, rustic packaging and a tied ribbon detail, this set is shelf-ready and ideal for boutiques, gift shops, and seasonal displays.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:22.851Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
